import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';

/** Temporary: remove once ChatGPT ads are reported again. */
const AdsReportingPausedNotice: React.FC = () => {
  const { t } = useTranslation();
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  return (
    <div className="ads-page__notice" role="status">
      <span className="ico--info ico--xs" aria-hidden="true" />
      <span>{t('ads.reportingPausedNotice')}</span>
      <Button
        className="ads-page__notice-close"
        type="button"
        aria-label={t('ads.dismissNotice')}
        title={t('ads.dismissNotice')}
        onClick={() => setIsDismissed(true)}
      >
        <span className="material-symbols-outlined" aria-hidden="true">
          close
        </span>
      </Button>
    </div>
  );
};

export default AdsReportingPausedNotice;
